import { Button } from '@library/components/buttons';
import arrowRightIcon from '@library/assets/images/icons/arrow-right.svg';
import { classNames } from '@library/utils';

export interface PaginationButtonsProps {
  currentPage: number;
  handlePageChange: (value: number) => void;
  totalPages: number;
}
export const PaginationButtons = ({
  currentPage,
  handlePageChange,
  totalPages
}: PaginationButtonsProps) => {
  const hidePrevious = currentPage < 2;
  const hideNext = totalPages <= 1 || currentPage === totalPages;
  const hidePagination = hidePrevious && hideNext;

  const handleButtonClick = (value: number) => {
    handlePageChange(value);
  };

  const buttonClassName =
    'bg-stankonia-100 text-soClean-100 rounded px-3 py-2.5 text-sm';

  return (
    <div
      className={classNames(
        'flex justify-end px-3 py-3',
        hidePagination ? 'hidden' : ''
      )}
    >
      <Button
        className={classNames(buttonClassName, hidePrevious ? 'hidden' : '')}
        title="PreviousPageButton"
        onClick={() => handleButtonClick(currentPage - 1)}
      >
        <div className="inline-flex items-center gap-2">
          <img
            alt="Arrow icon"
            className="h-3 w-2 rotate-180 pb-0.5"
            src={arrowRightIcon}
          />
          <span className="leading-none">Previous</span>
        </div>
      </Button>
      <span className="text-soClean-100 self-center px-4 text-xs">{`${currentPage} of ${totalPages}`}</span>
      <Button
        className={classNames(buttonClassName, hideNext ? 'hidden' : '')}
        title="NextPageButton"
        onClick={() => handleButtonClick(currentPage + 1)}
      >
        <div className="inline-flex items-center gap-2">
          <span className="leading-none">Next</span>
          <img
            alt="Arrow icon"
            className="h-3 w-2 pt-0.5"
            src={arrowRightIcon}
          />
        </div>
      </Button>
    </div>
  );
};
